// Recherche globale : courriers, dossiers et documents de la collectivité (GET /recherche, L0-C).
import { LIBELLES_ETATS_COURRIER, LIBELLES_ETATS_DOSSIER, type ResultatsRecherche } from '@cc/contrats/ui-metier';
import { EtatVide, Registre } from '@cc/ui';
import { useQuery } from '@tanstack/react-query';
import { Search } from 'lucide-react';
import { useSearchParams } from 'react-router';
import { requete } from '../../api/client';
import { EnTetePage } from '../../commun/EnTetePage';
import { EtatRequete } from '../../commun/EtatRequete';
import styles from './metier.module.css';

export function PageRecherche() {
  const [params] = useSearchParams();
  const q = params.get('q')?.trim() ?? '';
  const r = useQuery({
    queryKey: ['recherche', q],
    queryFn: ({ signal }) => requete<ResultatsRecherche>('/recherche', { signal, parametres: { q } }),
    enabled: q.length >= 2,
    retry: false,
  });
  const total = r.data ? r.data.courriers.length + r.data.dossiers.length + r.data.documents.length : 0;
  return (
    <>
      <EnTetePage etiquette="Recherche" titre={q ? `Résultats pour « ${q} »` : 'Recherche'} description={r.data ? `${total} résultat${total > 1 ? 's' : ''}, limités à vos droits.` : 'Saisissez au moins deux caractères dans la zone de recherche.'} />
      {q.length < 2 ? (
        <EtatVide titre="Aucune recherche en cours" icone={Search}>
          <p>Utilisez la zone de recherche en haut de l&apos;écran pour trouver un courrier, un dossier ou un document.</p>
        </EtatVide>
      ) : (
        <EtatRequete chargement={r.isPending} erreur={r.error} onReessayer={() => void r.refetch()} lot="L0-C" fonction="La recherche">
          {total === 0 ? (
            <EtatVide titre="Aucun résultat" icone={Search}>
              <p>Aucun élément accessible ne correspond à « {q} ».</p>
            </EtatVide>
          ) : (
            <div className={styles.pile}>
              {r.data && r.data.dossiers.length > 0 ? (
                <Registre titre="Dossiers" compteur={`${r.data.dossiers.length}`} elements={r.data.dossiers.map((d) => ({ id: d.id, reference: d.numero ?? 'sans numéro', objet: d.demarche, sousTitre: d.demandeur ?? undefined, etat: { ton: 'neutre', libelle: LIBELLES_ETATS_DOSSIER[d.etat] ?? d.etat }, href: `/dossiers/${d.id}` }))} />
              ) : null}
              {r.data && r.data.courriers.length > 0 ? (
                <Registre titre="Courriers" compteur={`${r.data.courriers.length}`} elements={r.data.courriers.map((c) => ({ id: c.id, reference: c.numero ?? 'sans numéro', objet: c.objet, sousTitre: c.correspondant, etat: { ton: 'neutre', libelle: LIBELLES_ETATS_COURRIER[c.etat] ?? c.etat }, href: `/courriers/${c.id}` }))} />
              ) : null}
              {r.data && r.data.documents.length > 0 ? (
                <Registre titre="Documents" compteur={`${r.data.documents.length}`} elements={r.data.documents.map((d) => ({ id: d.id, reference: d.type_document, objet: d.titre, href: `/documents?document=${d.id}` }))} />
              ) : null}
            </div>
          )}
        </EtatRequete>
      )}
    </>
  );
}
